module.exports = __webpack_public_path__ + "media/img/corporate/benefits-653d8337035826a345536e0175418295.svg";